import { styled } from '@mui/material';

import { Link } from 'react-router';

 import { Typography, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { MessageBus } from '@app-velocity/message-bus';
import { usePricing } from '@app-velocity/config';

import { Plan } from '../Plan';
import { usePaymentPlansContext } from '../../../../context/usePaymentPlansContext';
import { useStopSubscriptionMutation } from '../../../../queries/useStopSubscriptionMutation';

const StyledPrice = styled(Typography)(({ theme }) => ({
  fontSize: 40,
  fontWeight: 700,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  small: {
    fontSize: 13,
    fontWeight: 300,
  },
}));

const messageBus = new MessageBus('system');

export const FreePlan = () => {
  const { t } = useI18n();
  const { mainPath, tier } = usePaymentPlansContext();
  const { getPlanPrice } = usePricing();

  const { mutate: stopSubscription, isPending } = useStopSubscriptionMutation();

  const handleDowngrade = () => {
    messageBus.publish('modal:action-confirmation:open', {
      title: 'payments:downgrade_confirmation.title',
      description: 'payments:downgrade_confirmation.text',
      confirmButtonText: 'payments:downgrade',
      cancelButtonText: 'shared:cancel',
      confirmButtonColor: 'error',
      onModalCloseCallback: (decision) => {
        if (decision === 'CANCEL') return;

        stopSubscription();
      },
    });
  };

  return (
    <Plan
      highlighted={false}
      name="payments:plans.free.title"
      price={
        <StyledPrice>
          {getPlanPrice('free')}
          <small>{t('payments:per_month')}</small>
        </StyledPrice>
    }
      description={[
        'payments:plans.free.description.a',
        'payments:plans.free.description.b',
        'payments:plans.free.description.c',
        'payments:plans.free.description.d',
      ]}
      action={
        tier !== 'FREE' ? (
          <Button
            disabled={isPending}
            onClick={handleDowngrade}
            variant="contained"
            color="secondary"
          >
            {t('payments:downgrade')}
          </Button>
        ) : (
          <Button
            component={Link}
            to={mainPath}
            variant="contained"
            color="secondary"
            disabled
          >
            {t('payments:keep_plan')}
          </Button>
        )
      }
    />
  );
};
